/**
 * Resource identifier for `withResourceProtection` / `hasResource`.
 * Add an entry with this `name`/`component` to `resource_mappings` in the
 * login API response to grant access to summarization (Executive Summary on
 * Measure / Autopilot, and Nurturing Summary on Nurturing History).
 */
export const SUMMARIZATION_RESOURCE = 'Summarization';
